import React from 'react'
import AppShell from '../components/AppShell'
import NewContent from '../components/NewContent'

export default function NewTemplate() {
  return (
    <AppShell
      contentPreset="document"
      title="CMU Landscape Workspace"
      subtitle="ศูนย์รวมข้อมูลและคำแนะนำสำหรับการใช้งานระบบ Landscape Net Zero ในรูปแบบเดียวกับ backend"
    >
      <NewContent/>
    </AppShell>
  )
}
